/**
 * Order confirmation: the order number (the only reference for a guest) is copied with one click,
 * the account form cannot be sent twice.
 */
import {config} from './shared';

const copy = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
};

export const ThankYou = () => {
    const root = document.querySelector('.wbs-thankyou');
    if (!root) {
        return;
    }

    const i18n = (config() && config().i18n) || {};
    const status = root.querySelector('[data-copied]');

    root.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-copy]');
        if (!button) {
            return;
        }

        try {
            await copy(button.dataset.copy);
            button.classList.add('is-copied');
            if (status) {
                status.textContent = i18n.copied || '';
            }
            setTimeout(() => {
                button.classList.remove('is-copied');
                if (status) {
                    status.textContent = '';
                }
            }, 3000);
        } catch (e) {
            // Copying is a convenience - the number stays visible.
        }
    });

    const accountForm = root.querySelector('[data-account-form]');
    if (accountForm) {
        accountForm.addEventListener('submit', (event) => {
            const button = accountForm.querySelector('button[type="submit"]');
            if (button.disabled) {
                event.preventDefault();
                return;
            }
            button.classList.add('is-loading');
            setTimeout(() => {
                button.disabled = true;
            }, 0);
        });
    }
};
